/* eslint-disable import/no-default-export */
import { token, memberId } from '@trello/session-cookie';
import { clientVersion } from '@trello/config';
import PromiseQueue from './promise-queue';
import TrelloClient from './trello-client-js';

class API {
  client = new TrelloClient({
    getHeaders: () => {
      return {
        'X-Trello-Client-Version': clientVersion,
        'X-Trello-ReqId': `${memberId}-${Math.random()}`,
        //X-Trello-PreferMember: will be necessary for "One Account", please check https://extranet.atlassian.com/display/TRELLO/One+Account%3A+Technical+Implementation+Specification+v2.0
      };
    },
    getToken: () => token || '',
  });
  queue = new PromiseQueue();
}

export default new API();
